import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type DropDownMenuStyleType = {
  menuButton: SxProps
  menuButtonText: SxProps
  menu: SxProps
  menuItem: SxProps
}

export const dropDownMenuStyles: DropDownMenuStyleType = {
  menuButton: {
    height: '38px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.corporate.primaryColor}`,
    borderRadius: '4px',
    padding: theme.spacing(0.375, 1.5, 0, 1.5),
    backgroundColor: theme.corporate.secondaryColor,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: theme.colors.blue08
    },

    '&:focus-visible': {
      boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
    }
  },

  menuButtonText: {
    fontFamily: theme.corporate.primaryFont,
    fontSize: 16,
    fontWeight: '700',
    color: theme.corporate.primaryColor
  },

  menu: {
    '& .MuiPaper-root': {
      borderRadius: '4px',
      marginTop: theme.spacing(0.5),
      boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
    },
    '& .MuiList-root': {
      padding: theme.spacing(0.5)
    }
  },

  menuItem: {
    display: 'flex',
    height: '38px',
    width: '202px',
    padding: theme.spacing(1, 0.5),
    fontSize: 14,
    fontFamily: theme.corporate.secondaryFont,
    color: theme.colors.gray14,

    '&:hover': {
      backgroundColor: theme.colors.gray15
    },

    '& .MuiTypography-root': {
      fontSize: 14,
      fontFamily: theme.corporate.secondaryFont,
      color: theme.colors.gray14
    }
  }
}
